import { createIcon } from '@chakra-ui/icons';

export const Files = createIcon({
  displayName: 'Files',
  viewBox: '0 0 21 24',
  d: 'M3.66102 20.339L20.339 20.339L20.339 6.69915L13.678 -1.19577e-06L3.66101 -3.20056e-07L3.66102 20.339ZM18.3051 7.53813L18.3051 18.3051L5.69491 18.3051L5.69491 2.0339L12.8263 2.0339L18.3051 7.53813ZM12.6102 7.72881L12.6102 3.66102L10.5763 3.66102L10.5763 9.76271L16.678 9.76271L16.678 7.72881L12.6102 7.72881ZM16.678 24L16.678 21.9661L2.0339 21.9661L2.0339 3.66102L-1.77809e-06 3.66102L0 24L16.678 24Z',
});
